const FeedbackNotImplemented = () => 'Feedback non implementato.';

export default FeedbackNotImplemented;
